module.exports = __webpack_public_path__ + "static/media/悬浮球@2x.dd63b591.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/悬浮球@2x.png
// module id = 1404
// module chunks = 0